import type { IKazooIdToken } from "./IKazooIdToken";

function presentOrNotPresent(value?: unknown) {
  if (value) {
    return "PRESENT";
  }
  return "NOT PRESENT";
}

/**
 * Give this a kazoo token and it returns something safe to put in logs.
 */
export function sanitizeTokenForLogging(idToken?: IKazooIdToken | null) {
  if (idToken) {
    return {
      ...idToken,
      hgActAsUserToken: presentOrNotPresent(idToken.hgActAsUserToken),
      hgToken: presentOrNotPresent(idToken.hgToken),
      yeiToken: presentOrNotPresent(idToken.yeiToken),
    };
  }
}
